export default {
	title: "Ruote della Fortuna",
	Lucky: "Fortunato",
	wheels: "Ruote",
	winningrecord: "Registro Vincite",
	ActivityRules: "Regole dell'Attività",
	ActivityRulesContent: "Per ulteriori informazioni sulla lotteria, contatta il nostro servizio clienti.",
	award: {
		title: "Congratulazioni per la vincita!",
		btn: "Ricevi il premio"
	},
	noticeItem: "{0} ha ottenuto {1}",
	lotteryDraws: "{0} estrazioni della lotteria",
	noAvailableTimes: "Tentativi insufficienti disponibili. Contatta il servizio clienti.",
	noOpen: "Non ancora aperto",
	noWinning: "Continua a provare",
	ViewALlPrizes: "Vedi tutti i premi",
	myPrizes: "I miei premi",
	share: "Condividi con un amico"
};
